import { Tabs } from "antd";
import COLORS from "common/Colors";
import Myleavereport from "pages/Myleavereport";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getMenuList, getUserRoleId } from "redux/selectors";
import styled from "styled-components";
import MyOvertime from "./MyOvertime";
import MyWorkFromHome from "./MyWorkFromHome";
import MyTimeOff from "./MyTimeOff";
import { useTranslation } from "react-i18next";
import MyAssets from "pages/AssetManagement/MyAssets";

const HistoryWrap = styled.div`
  .ant-tabs-nav {
    border-radius: 5px;
    font-weight: 500;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .ant-tabs-tab {
    font-size: 16px;
    &:hover {
      color: ${COLORS.TEXT.PRIMARY};
    }
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.TAB};
    font-weight: bold;
    position: absolute;
    bottom: -1px !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.TAB};
    font-weight: 500;
    font-size: 16px;
  }

  .ant-tabs-nav::before {
    border: none !important;
  }
  .ant-tabs-nav-list {
    border-bottom: 2px solid #80808033;
  }

  @media (min-width: 320px) and (max-width: 420px) {
    .ant-tabs-tab {
      margin: 0 !important;
    }
    .ant-tabs-nav .ant-tabs-nav-list {
      gap: 1rem;
    }
  }
`;

const MyHistoy = () => {
  const { t } = useTranslation();

  const menuList = useSelector(getMenuList);
  const userRoleId = useSelector(getUserRoleId);

  const Menulist =
    menuList[userRoleId] || Object.values(menuList)[0] || menuList;

  const isLeaveAccess = Menulist?.find(
    (item) => item?.key === "leavereport" && item?.permission.view
  );
  const isWfhAccess = Menulist?.find(
    (item) => item?.key === "wfhreq" && item?.permission.view
  );
  const isPermissionAccess = Menulist?.find(
    (item) => item?.key === "permissionreq" && item?.permission.view
  );
  const isOvertimeAccess = Menulist?.find(
    (item) => item?.key === "overtimereq" && item?.permission.view
  );
  const isAssetAccess = Menulist?.find(
    (item) => item?.key === "myassets" && item?.permission.view
  );

  const [tabId, setTabId] = useState(
    isLeaveAccess
      ? "1"
      : isOvertimeAccess
      ? "2"
      : isWfhAccess
      ? "3"
      : isPermissionAccess
      ? "4"
      : "5"
  );

  const onChange = (key) => {
    setTabId(key);
  };

  const items = [
    isLeaveAccess && {
      key: "1",
      label: t("Leave"),
      children: <Myleavereport />,
    },
    isOvertimeAccess && {
      key: "2",
      label: t("Overtime"),
      children: <MyOvertime />,
    },
    isWfhAccess && {
      key: "3",
      label: t("WFH"),
      children: <MyWorkFromHome />,
    },
    isPermissionAccess && {
      key: "4",
      label: t("Time Off in Lieu"),
      children: <MyTimeOff />,
    },
    isAssetAccess && {
      key: "5",
      label: t("Asset Ticket"),
      children: <MyAssets />,
    },
  ].filter(Boolean);

  return (
    <HistoryWrap>
      <h6>{t("My History")}</h6>
      <Tabs defaultActiveKey={tabId} items={items} onChange={onChange} />
    </HistoryWrap>
  );
};

export default MyHistoy;
